(function () {
    'use strict';

    angular
        .module('app.application')
        .controller('ApplicationOverviewController', ApplicationOverviewController);

    /*jshint -W072, -W071 */
    /* @ngInject */
    function ApplicationOverviewController(
        $q,
        $stateParams,
        $uibModal,
        logger,
        applicationService,
        userService,
        userApplicationService,
        roleService,
        userRoleService,
        moment,
        dialogService, $timeout) {

        //Private Variables
        var vm = this;
        var userApplicationModalOptions = userApplicationService.getModalOptions();


        //Public Variables
        vm.application = {};
        vm.title = '';
        vm.applicationFields = applicationService.getApplicationOverviewFields();
        vm.users = [];
        vm.administrators = [];
        vm.user = userService.getDefaultUser();
        vm.administrator = userService.getDefaultUser();
        vm.roles = [];
        vm.totalUsers = 0;
        vm.totalRoles = 0;
        vm.totalAdministrators = 0;
        vm.isFilterCollapsed = true;
        vm.userTableConfig = { columns: [] };
        vm.roleTableConfig = configureRoleTableActions();

        //Public Methods
        vm.getUsers = getUsersByApplication;
        vm.getRolesByApplication = getRolesByApplication;
        vm.getAdministratorsByApplication = getAdministratorsByApplication;
        vm.refresh = refresh;

        // Smart Table

        // DI / IOC / unit testing / mocking


        //Activate Controller
        activate();

        function activate() {
            //
            var promises = [getApplication(), getRoles()];
            return $q.all(promises).then(function () {
                vm.userTableConfig = configureUserTableActions(vm.roles);
                setAdministratorForm();
                setUserForm();
                logger.info('Activated application Overview View');
            });
        }

        function getApplication() {
            return applicationService.getApplication($stateParams.ApplicationID)
                .then(function (result) {
                    vm.application = result;
                    vm.title = vm.application.ApplicationName;
                    vm.application.DateCreated = moment(result.DateCreated).toDate();
                    vm.application.DateUpdated = moment(result.DateUpdated).toDate();
                });
        }

        function getRolesByApplication(tableState) {
            return roleService.getRolesByApplication($stateParams.ApplicationID, tableState)
                .then(function (result) {
                    vm.totalRoles = result.count;

                    return result;
                });
        }



        function configureUserTableActions(roles) {
            angular.forEach(roles, function (role) {
                role.name = role.RoleName;
                role.value = role.RoleId;
            });
            return {
                columns: [
                    {
                        id: 'Email',
                        displayName: 'Email',
                        ODataKey: 'User/Email',
                        type: 'subItem'
                    },
                    {
                        id: 'IsActive',
                        displayName: 'Is Active',
                        ODataKey: 'IsActive',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'Active'
                            },
                            off: {
                                className: 'danger',
                                display: 'Inactive'
                            }
                        }
                    },
                    {
                        id: 'roles',
                        displayName: 'Roles',
                        ODataKey: 'User/UserRoleTies/RoleId',
                        type: 'multiSelect',
                        itemLabel: 'RoleName',
                        itemId: 'RoleId',
                        itemParentID: 'UserId',
                        itemAdded: saveUserRole,
                        itemRemoved: deleteUserRole,
                        options: roles,
                        placeholder: 'Please Select User Role'
                    }
                ],
                actions: [{
                    name: '"Edit"',
                    action: editUserApplication,
                    icon: 'fa-edit',
                    permission: ['SSO:SysAdmin', 'SSO:AppAdmin']
                }, {
                    name: '"Delete"',
                    action: deleteUserApplication,
                    icon: 'fa-warning',
                    permission: ['SSO:SysAdmin', 'SSO:AppAdmin']
                }]
            };
        }

        function configureRoleTableActions() {
            var tableConfig = roleService.getTableConfig();
            return tableConfig;
        }

        function getAdministratorsByApplication(tablestate) {
            return userApplicationService.getAdministratorsByApplication(tablestate,
                vm.userTableConfig,
                $stateParams.ApplicationID)
            .then(function (result) {
                vm.totalAdministrators = result.count;
                angular.forEach(result, function (user) {
                    flattentRoles(user);
                });
                return result;
            });
        }

        function getUsersByApplication(tablestate) {
            return userApplicationService.getUsersByApplication(tablestate,
                vm.userTableConfig,
                $stateParams.ApplicationID)
            .then(function (result) {
                vm.totalUsers = result.count;
                angular.forEach(result, function (user) {
                    flattentRoles(user);
                });
                return result;
            });
        }

        function setUserForm() {
            vm.userFields = userService.getUserSearchField($stateParams.ApplicationID, userAddClick);
        }

        function setAdministratorForm() {
            vm.administratorSearchFields = userService.getAdministratorSearchField($stateParams.ApplicationID,
                administratorAddClick);
        }

        function userAddClick($event, user) {
            userService.getUser(user.user.UserId)
                .then(function (result) {
                    saveUserApplication(result);
                });
        }

        function administratorAddClick($event, user) {
            userService.getUser(user.user.UserId)
                .then(function (result) {
                    saveUserApplicationAdministrator(result);

                });
        }

        function flattentRoles(user) {
            user.roles = [];
            angular.forEach(user.User.UserRoleTies, function (role) {
                if (role.Role.Application.ApplicationId === parseInt($stateParams.ApplicationID)) {
                    user.roles.push(role.Role);
                }
            });
        }

        function saveUserApplication(user) {

            var userApplication = {
                ApplicationId: $stateParams.ApplicationID,
                UserId: user.UserId,
                IsActive: true,
                LegacyUserId: ''
            };

            userApplicationService.saveUserApplication(userApplication)
                .then(function (result) {
                    var userApplication = result.data;
                    userApplication.User = user;
                    flattentRoles(userApplication);
                    vm.totalUsers = vm.totalUsers + 1;
                    vm.users.unshift(userApplication);
                    vm.user.user = '';
                });
        }

        function saveUserApplicationAdministrator(user) {
            var userApplication = {
                ApplicationId: $stateParams.ApplicationID,
                UserId: user.UserId,
                IsActive: true,
                LegacyUserId: ''
            };
            userApplicationService.saveUserApplicationAdministrator(user.UserId, userApplication)
                .then(function (result) {
                    var userApplication = result.data;
                    userApplication.User = user;
                    flattentRoles(userApplication);
                    vm.totalUsers = vm.totalUsers + 1;
                    vm.totalAdministrators = vm.totalAdministrators + 1;
                    vm.users.unshift(userApplication);
                    vm.administrators.unshift(userApplication);
                    vm.user.user = '';
                    vm.administrator.user = '';
                });
        }

        function getRoles() {
            return roleService.getAllRolesByApplication($stateParams.ApplicationID)
                .then(function (result) {
                    vm.roles = result;
                });
        }

        function saveUserRole(userID, item) {
            var userRole = {
                RoleId: item.RoleId,
                UserId: userID
            };

            return userRoleService.saveUserRole(userRole);
        }

        function deleteUserRole(userID, item) {
            return userRoleService.deleteUserRoleByUserAndRole(userID, item.RoleId);
        }

        function deleteUserApplication(user) {
            return dialogService.confirm()
               .then(function () {
                   return userApplicationService.deleteUserApplicationByUserAndApplication(
                       user.UserId, $stateParams.ApplicationID);
               }).then(function (result) {
                   if (result.status === 200) {
                       var index = vm.users.indexOf(user);
                       var adminIndex = vm.administrators.indexOf(user);
                       vm.users.splice(index, 1);
                       vm.administrators.splice(adminIndex, 1);
                       vm.totalUsers = vm.totalUsers - 1;
                       if (adminIndex >= 0) {
                           vm.totalAdministrators = vm.totalAdministrators - 1;
                       }
                       logger.info('User Deleted', result);
                   } else {
                       logger.error('Error Deleting User Application', result);
                   }
               });
        }

        function editUserApplication(userApplication) {
            userApplicationModalOptions.controller = 'UserApplicationEditController';
            var modalInstance = $uibModal.open(angular.extend({
                resolve: {
                    userApplication: function () {
                        return userApplication;
                    }
                }
            }, userApplicationModalOptions));

            modalInstance.result.then(function (updateduserApplication) {
                userApplication = updateduserApplication;
            }, function () {
                logger.info('Modal dismissed at: ' + moment().format());
            });
        }

        //hack to make the multiple selects update the input width
        function refresh() {
            $timeout(function () { }, 100);
        }
    }
})();
